import "./cameraEditor.1acb9652.js";
import "./cameraEditor.737f6996.js";
import "./dhLinks.29e4c113.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $jw0R5 = parcelRequire("jw0R5");

var $2sw9m = parcelRequire("2sw9m");

var $ctZJO = parcelRequire("ctZJO");

var $6BOAB = parcelRequire("6BOAB");

var $bPqRC = parcelRequire("bPqRC");

var $6SpCP = parcelRequire("6SpCP");
let $272bbf19d32de2d1$var$scene, $272bbf19d32de2d1$var$camera, $272bbf19d32de2d1$var$renderer, $272bbf19d32de2d1$var$controls, $272bbf19d32de2d1$var$pane;
let $272bbf19d32de2d1$var$createFolder, $272bbf19d32de2d1$var$armsFolder, $272bbf19d32de2d1$var$styleFolder;
let $272bbf19d32de2d1$var$chain;
let $272bbf19d32de2d1$var$suppressUpdate = false;
let $272bbf19d32de2d1$var$armFolderApis = [];
let $272bbf19d32de2d1$var$styleBindings = [];
const $272bbf19d32de2d1$var$BG_COLOR = 0x242a2e;
const $272bbf19d32de2d1$var$FRAME_RATE = 30;
const $272bbf19d32de2d1$var$DEFAULT_EXPOSURE = 1.2;
const $272bbf19d32de2d1$var$renderLoop = (0, $6BOAB.getRenderLoopController)();
const $272bbf19d32de2d1$var$styleParams = {
    jointColor: 0x7d7d7d,
    linkColor: 0x000000,
    randomJointColor: true,
    randomLinkColor: false,
    jointRadius: 0.025,
    jointHeight: 0.05,
    linkRadius: 0.01,
    showAxisHelper: false,
    showDOFHelper: true,
    dofColor: 0xffa500,
    dofOpacity: 0.25,
    dofUseJointColor: true,
    dofUseAutoRadius: false,
    dofRadius: 0.1,
    dofRadiusScale: 0.25,
    dofThicknessRatio: 0.3,
    dofSegments: 64,
    dofOffsetZ: 1e-4,
    axisHelperSize: 0.1,
    syncUp: true,
    litMaterials: true,
    roughness: 0.42,
    metalness: 0.24,
    castShadow: true,
    receiveShadow: true
};
const $272bbf19d32de2d1$var$defaultStyleParams = JSON.parse(JSON.stringify($272bbf19d32de2d1$var$styleParams));
const $272bbf19d32de2d1$var$baseParams = {
    mdhMode: false,
    useConvertedParams: false,
    baseOffset: {
        x: 0,
        y: 0,
        z: 0
    }
};
function $272bbf19d32de2d1$var$resetStyles() {
    Object.assign($272bbf19d32de2d1$var$styleParams, $272bbf19d32de2d1$var$defaultStyleParams);
    $272bbf19d32de2d1$var$saveStyles();
    $272bbf19d32de2d1$var$updateArm();
    for (const binding of $272bbf19d32de2d1$var$styleBindings)binding.refresh();
}
function $272bbf19d32de2d1$var$saveStyles() {
    localStorage.setItem('dhArmStyles', JSON.stringify($272bbf19d32de2d1$var$styleParams));
}
function $272bbf19d32de2d1$var$loadStyles() {
    const savedStyles = localStorage.getItem('dhArmStyles');
    if (savedStyles) Object.assign($272bbf19d32de2d1$var$styleParams, JSON.parse(savedStyles));
}
$272bbf19d32de2d1$var$loadStyles();
const $272bbf19d32de2d1$var$createParams = {
    armSegments: [],
    reset: function() {
        for (const folder of $272bbf19d32de2d1$var$armFolderApis)folder.dispose();
        $272bbf19d32de2d1$var$armFolderApis = [];
        $272bbf19d32de2d1$var$createParams.armSegments.length = 0;
        $272bbf19d32de2d1$var$chain.generate([], $272bbf19d32de2d1$var$styleParams, $272bbf19d32de2d1$var$baseParams);
        $272bbf19d32de2d1$var$renderLoop.requestRender();
    },
    addArmSegment: function(initialParams) {
        initialParams = initialParams || {};
        const linkIndex = this.armSegments.length;
        const armParams = {
            theta: initialParams.theta ?? 0,
            axisSign: initialParams.axisSign === -1 ? -1 : 1,
            thetaOffset: initialParams.thetaOffset ?? 0,
            d: initialParams.d ?? 0,
            a: initialParams.a ?? 1,
            alpha: initialParams.alpha ?? 0,
            minAngle: initialParams.minAngle ?? 0,
            maxAngle: initialParams.maxAngle ?? 360,
            name: `link_${linkIndex + 1}`,
            remove: null
        };
        this.armSegments.push(armParams);
        const armFolder = $272bbf19d32de2d1$var$armsFolder.addFolder({
            title: armParams.name
        });
        $272bbf19d32de2d1$var$armFolderApis.push(armFolder);
        armParams.remove = function() {
            const armIndex = $272bbf19d32de2d1$var$createParams.armSegments.indexOf(armParams);
            if (armIndex > -1) $272bbf19d32de2d1$var$createParams.armSegments.splice(armIndex, 1);
            const folderIndex = $272bbf19d32de2d1$var$armFolderApis.indexOf(armFolder);
            if (folderIndex > -1) $272bbf19d32de2d1$var$armFolderApis.splice(folderIndex, 1);
            armFolder.dispose();
            $272bbf19d32de2d1$var$updateArm();
        };
        armFolder.addBinding(armParams, 'theta', {
            min: -180,
            max: 180,
            label: 'Theta'
        }).on('change', (ev)=>{
            if (ev.last === false) return;
            $272bbf19d32de2d1$var$updateArm();
        });
        armFolder.addBinding(armParams, 'axisSign', {
            label: 'Axis Sign',
            options: {
                '+1': 1,
                '-1': -1
            }
        }).on('change', (ev)=>{
            if (ev.last === false) return;
            $272bbf19d32de2d1$var$updateArm();
        });
        armFolder.addBinding(armParams, 'thetaOffset', {
            min: armParams.minAngle,
            max: armParams.maxAngle,
            label: 'Theta Offset'
        }).on('change', (ev)=>{
            if (ev.last === false) return;
            $272bbf19d32de2d1$var$updateArm();
        });
        armFolder.addBinding(armParams, 'd', {
            min: -10,
            max: 10,
            label: 'd'
        }).on('change', (ev)=>{
            if (ev.last === false) return;
            $272bbf19d32de2d1$var$updateArm();
        });
        armFolder.addBinding(armParams, 'a', {
            min: -10,
            max: 10,
            label: 'a'
        }).on('change', (ev)=>{
            if (ev.last === false) return;
            $272bbf19d32de2d1$var$updateArm();
        });
        armFolder.addBinding(armParams, 'alpha', {
            min: -180,
            max: 180,
            label: 'Alpha'
        }).on('change', (ev)=>{
            if (ev.last === false) return;
            $272bbf19d32de2d1$var$updateArm();
        });
        armFolder.addButton({
            title: 'Remove Arm Segment'
        }).on('click', ()=>{
            armParams.remove();
        });
        armFolder.expanded = true;
        $272bbf19d32de2d1$var$pane.element.scrollTop = $272bbf19d32de2d1$var$pane.element.scrollHeight;
        $272bbf19d32de2d1$var$updateArm();
    }
};
function $272bbf19d32de2d1$var$segmentsToParamArray(segments) {
    return segments.map((segment)=>[
            segment.theta ?? 0,
            segment.d ?? 0,
            segment.a ?? 0,
            segment.alpha ?? 0,
            segment.thetaOffset ?? 0,
            segment.minAngle ?? -185,
            segment.maxAngle ?? 185,
            segment.axisSign === -1 ? -1 : 1
        ]);
}
function $272bbf19d32de2d1$var$rebuildSegmentsFromArray(paramArray) {
    $272bbf19d32de2d1$var$suppressUpdate = true;
    for (const folder of $272bbf19d32de2d1$var$armFolderApis)folder.dispose();
    $272bbf19d32de2d1$var$armFolderApis = [];
    $272bbf19d32de2d1$var$createParams.armSegments.length = 0;
    paramArray.forEach((params)=>{
        $272bbf19d32de2d1$var$createParams.addArmSegment({
            theta: params[0],
            d: params[1],
            a: params[2],
            alpha: params[3],
            thetaOffset: params[4],
            minAngle: params[5],
            maxAngle: params[6],
            axisSign: params[7]
        });
    });
    $272bbf19d32de2d1$var$suppressUpdate = false;
    $272bbf19d32de2d1$var$updateArm();
}
function $272bbf19d32de2d1$var$convertAxisLimitsToDh(segment) {
    // Convert axis-space limits to DH-space limits.
    // Wrap intervals (min > max) are preserved so DOF helper and solver share semantics.
    const axisSign = segment.axisSign === -1 ? -1 : 1;
    const thetaOffsetDeg = segment.thetaOffset ?? 0;
    const minAxisDeg = segment.minAngle ?? -185;
    const maxAxisDeg = segment.maxAngle ?? 185;
    const isWrap = minAxisDeg > maxAxisDeg;
    const mappedMin = axisSign * minAxisDeg + thetaOffsetDeg;
    const mappedMax = axisSign * maxAxisDeg + thetaOffsetDeg;
    if (!isWrap) return mappedMin <= mappedMax ? [
        mappedMin,
        mappedMax
    ] : [
        mappedMax,
        mappedMin
    ];
    return axisSign === 1 ? [
        mappedMin,
        mappedMax
    ] : [
        mappedMax,
        mappedMin
    ];
}
function $272bbf19d32de2d1$var$createDhParametersFromSegments(segments) {
    return segments.map((segment)=>{
        const theta = (0, $jw0R5.MathUtils).degToRad(segment.theta);
        const thetaOffset = (0, $jw0R5.MathUtils).degToRad(segment.thetaOffset ?? 0);
        const d = segment.d;
        const a = segment.a;
        const alpha = (0, $jw0R5.MathUtils).degToRad(segment.alpha);
        const [minDhDeg, maxDhDeg] = $272bbf19d32de2d1$var$convertAxisLimitsToDh(segment);
        return [
            theta,
            d,
            a,
            alpha,
            thetaOffset,
            minDhDeg,
            maxDhDeg,
            segment.axisSign === -1 ? -1 : 1
        ];
    });
}
const $272bbf19d32de2d1$var$presets = {
    'TEST': {
        segments: [
            {
                theta: 0,
                d: 0.5,
                a: 1,
                alpha: 90,
                thetaOffset: 0,
                minAngle: -185,
                maxAngle: 185,
                axisSign: 1
            },
            {
                theta: 0,
                d: 0.5,
                a: 1,
                alpha: 90,
                thetaOffset: 0,
                minAngle: -185,
                maxAngle: 185,
                axisSign: 1
            },
            {
                theta: 0,
                d: 0,
                a: 1,
                alpha: 90,
                thetaOffset: 0,
                minAngle: -185,
                maxAngle: 185,
                axisSign: 1
            }
        ]
    },
    'KUKA KR5': {
        segments: [
            {
                theta: 0,
                d: 0.4,
                a: 0.18,
                alpha: 90,
                thetaOffset: 0,
                minAngle: -155,
                maxAngle: 155,
                axisSign: 1
            },
            {
                theta: 90,
                d: 0,
                a: 0.6,
                alpha: 0,
                thetaOffset: 0,
                minAngle: -180,
                maxAngle: 65,
                axisSign: -1
            },
            {
                theta: 0,
                d: 0,
                a: 0.12,
                alpha: 90,
                thetaOffset: 0,
                minAngle: -15,
                maxAngle: 158,
                axisSign: 1
            },
            {
                theta: 0,
                d: 0.62,
                a: 0,
                alpha: -90,
                thetaOffset: 0,
                minAngle: -350,
                maxAngle: 350,
                axisSign: 1
            },
            {
                theta: 0,
                d: 0,
                a: 0,
                alpha: 90,
                thetaOffset: 0,
                minAngle: -130,
                maxAngle: 130,
                axisSign: 1
            },
            {
                theta: 0,
                d: 0.115,
                a: 0,
                alpha: 0,
                thetaOffset: 0,
                minAngle: -350,
                maxAngle: 350,
                axisSign: 1
            }
        ]
    },
    'PUMA 560': {
        segments: [
            {
                theta: 0,
                d: 0.67183,
                a: 0.0,
                alpha: 90,
                minAngle: -160,
                maxAngle: 160
            },
            {
                theta: 0,
                d: 0.0,
                a: 0.4318,
                alpha: 0,
                minAngle: -110,
                maxAngle: 110
            },
            {
                theta: 0,
                d: 0.15005,
                a: 0.0203,
                alpha: -90,
                minAngle: -135,
                maxAngle: 135
            },
            {
                theta: 0,
                d: 0.4318,
                a: 0.0,
                alpha: 90,
                minAngle: -266,
                maxAngle: 266
            },
            {
                theta: 0,
                d: 0.0,
                a: 0.0,
                alpha: -90,
                minAngle: -100,
                maxAngle: 100
            },
            {
                theta: 0,
                d: 0.0,
                a: 0.0,
                alpha: 0,
                minAngle: -266,
                maxAngle: 266
            }
        ]
    },
    'Simple 6-DOF': {
        segments: [
            {
                theta: 0,
                d: 0.5,
                a: 0,
                alpha: 0
            },
            {
                theta: 0,
                d: 0.5,
                a: 0,
                alpha: 0
            },
            {
                theta: 0,
                d: 0.5,
                a: 0,
                alpha: 0
            },
            {
                theta: 0,
                d: 0.5,
                a: 0,
                alpha: 0
            },
            {
                theta: 0,
                d: 0.5,
                a: 0,
                alpha: 0
            },
            {
                theta: 0,
                d: 0.25,
                a: 0,
                alpha: 0
            }
        ]
    }
};
function $272bbf19d32de2d1$var$loadPreset(name) {
    const preset = $272bbf19d32de2d1$var$presets[name];
    if (!preset) return;
    const paramsArray = preset.segments.map((params)=>[
            params.theta ?? 0,
            params.d ?? 0,
            params.a ?? 0,
            params.alpha ?? 0,
            params.thetaOffset ?? 0,
            params.minAngle ?? -185,
            params.maxAngle ?? 185,
            params.axisSign === -1 ? -1 : 1
        ]);
    if ($272bbf19d32de2d1$var$baseParams.mdhMode) {
        $272bbf19d32de2d1$var$baseParams.useConvertedParams = true;
        $272bbf19d32de2d1$var$rebuildSegmentsFromArray((0, $6SpCP.convertMDH)(paramsArray));
    } else {
        $272bbf19d32de2d1$var$baseParams.useConvertedParams = false;
        $272bbf19d32de2d1$var$rebuildSegmentsFromArray(paramsArray);
    }
}
const $272bbf19d32de2d1$var$demoParams = {
    'TEST': ()=>$272bbf19d32de2d1$var$loadPreset('TEST'),
    'KUKA KR5': ()=>$272bbf19d32de2d1$var$loadPreset('KUKA KR5'),
    'PUMA 560': ()=>$272bbf19d32de2d1$var$loadPreset('PUMA 560'),
    'Simple 6-DOF': ()=>$272bbf19d32de2d1$var$loadPreset('Simple 6-DOF')
};
$272bbf19d32de2d1$var$init();
function $272bbf19d32de2d1$var$init() {
    $272bbf19d32de2d1$var$scene = new (0, $jw0R5.Scene)();
    $272bbf19d32de2d1$var$scene.background = new (0, $jw0R5.Color)($272bbf19d32de2d1$var$BG_COLOR);
    $272bbf19d32de2d1$var$camera = new (0, $jw0R5.PerspectiveCamera)(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    $272bbf19d32de2d1$var$camera.position.set(1.5, 1.3, 1.5);
    $272bbf19d32de2d1$var$renderer = new (0, $jw0R5.WebGLRenderer)({
        antialias: true
    });
    $272bbf19d32de2d1$var$renderer.setPixelRatio(window.devicePixelRatio);
    $272bbf19d32de2d1$var$renderer.setSize(window.innerWidth, window.innerHeight);
    $272bbf19d32de2d1$var$renderer.setClearColor($272bbf19d32de2d1$var$BG_COLOR, 1);
    $272bbf19d32de2d1$var$renderer.outputColorSpace = (0, $jw0R5.SRGBColorSpace);
    $272bbf19d32de2d1$var$renderer.toneMapping = (0, $jw0R5.ACESFilmicToneMapping);
    $272bbf19d32de2d1$var$renderer.toneMappingExposure = $272bbf19d32de2d1$var$DEFAULT_EXPOSURE;
    $272bbf19d32de2d1$var$renderer.shadowMap.enabled = true;
    $272bbf19d32de2d1$var$renderer.shadowMap.type = (0, $jw0R5.PCFSoftShadowMap);
    document.body.appendChild($272bbf19d32de2d1$var$renderer.domElement);
    $272bbf19d32de2d1$var$controls = new (0, $2sw9m.OrbitControls)($272bbf19d32de2d1$var$camera, $272bbf19d32de2d1$var$renderer.domElement);
    $272bbf19d32de2d1$var$controls.target.set(0.25, 0.5, -0.25);
    $272bbf19d32de2d1$var$controls.update();
    $272bbf19d32de2d1$var$controls.addEventListener('change', ()=>{
        $272bbf19d32de2d1$var$renderLoop.requestRender();
    });
    $272bbf19d32de2d1$var$addEnvironment();
    $272bbf19d32de2d1$var$chain = new (0, $bPqRC.Chain)($272bbf19d32de2d1$var$scene);
    $272bbf19d32de2d1$var$renderLoop.configure({
        fps: $272bbf19d32de2d1$var$FRAME_RATE,
        render: $272bbf19d32de2d1$var$renderFrame
    });
    $272bbf19d32de2d1$var$renderLoop.setContinuous(false);
    $272bbf19d32de2d1$var$renderLoop.setRenderOnIdle(false);
    $272bbf19d32de2d1$var$pane = new (0, $ctZJO.Pane)({
        title: 'DH Links',
        container: document.getElementById('control-panel')
    });
    const bindStyle = (folder, key, options = {})=>{
        const binding = folder.addBinding($272bbf19d32de2d1$var$styleParams, key, options);
        binding.on('change', (ev)=>{
            if (ev.last === false) return;
            $272bbf19d32de2d1$var$updateArm();
            $272bbf19d32de2d1$var$saveStyles();
        });
        $272bbf19d32de2d1$var$styleBindings.push(binding);
        return binding;
    };
    $272bbf19d32de2d1$var$createFolder = $272bbf19d32de2d1$var$pane.addFolder({
        title: 'Create'
    });
    $272bbf19d32de2d1$var$createFolder.addButton({
        title: 'Add Arm Segment'
    }).on('click', ()=>$272bbf19d32de2d1$var$createParams.addArmSegment());
    $272bbf19d32de2d1$var$createFolder.addButton({
        title: 'Reset'
    }).on('click', ()=>$272bbf19d32de2d1$var$createParams.reset());
    $272bbf19d32de2d1$var$createFolder.expanded = true;
    const demoFolder = $272bbf19d32de2d1$var$pane.addFolder({
        title: 'Demo'
    });
    demoFolder.addButton({
        title: 'TEST'
    }).on('click', ()=>$272bbf19d32de2d1$var$demoParams.TEST());
    demoFolder.addButton({
        title: 'KUKA KR5'
    }).on('click', ()=>$272bbf19d32de2d1$var$demoParams['KUKA KR5']());
    demoFolder.addButton({
        title: 'PUMA 560'
    }).on('click', ()=>$272bbf19d32de2d1$var$demoParams['PUMA 560']());
    demoFolder.addButton({
        title: 'Simple 6-DOF'
    }).on('click', ()=>$272bbf19d32de2d1$var$demoParams['Simple 6-DOF']());
    demoFolder.expanded = true;
    const baseFolder = $272bbf19d32de2d1$var$pane.addFolder({
        title: 'Base'
    });
    baseFolder.addBinding($272bbf19d32de2d1$var$baseParams, 'mdhMode', {
        label: 'MDH Mode'
    }).on('change', (ev)=>{
        if (ev.last === false) return;
        const value = ev.value;
        const params = $272bbf19d32de2d1$var$segmentsToParamArray($272bbf19d32de2d1$var$createParams.armSegments);
        const converted = value ? (0, $6SpCP.convertMDH)(params) : (0, $6SpCP.convertDH)(params);
        $272bbf19d32de2d1$var$baseParams.useConvertedParams = value;
        $272bbf19d32de2d1$var$rebuildSegmentsFromArray(converted);
    });
    const baseOffsetFolder = baseFolder.addFolder({
        title: 'Offset'
    });
    baseOffsetFolder.addBinding($272bbf19d32de2d1$var$baseParams.baseOffset, 'x', {
        min: -10,
        max: 10,
        label: 'Offset X'
    }).on('change', (ev)=>{
        if (ev.last === false) return;
        $272bbf19d32de2d1$var$updateArm();
    });
    baseOffsetFolder.addBinding($272bbf19d32de2d1$var$baseParams.baseOffset, 'y', {
        min: -10,
        max: 10,
        label: 'Offset Y'
    }).on('change', (ev)=>{
        if (ev.last === false) return;
        $272bbf19d32de2d1$var$updateArm();
    });
    baseOffsetFolder.addBinding($272bbf19d32de2d1$var$baseParams.baseOffset, 'z', {
        min: -10,
        max: 10,
        label: 'Offset Z'
    }).on('change', (ev)=>{
        if (ev.last === false) return;
        $272bbf19d32de2d1$var$updateArm();
    });
    baseFolder.expanded = true;
    $272bbf19d32de2d1$var$styleFolder = $272bbf19d32de2d1$var$pane.addFolder({
        title: 'Visualization'
    });
    const jointsLinksFolder = $272bbf19d32de2d1$var$styleFolder.addFolder({
        title: 'Joints && Links'
    });
    bindStyle(jointsLinksFolder, 'jointColor', {
        label: 'Joint Color',
        view: 'color'
    });
    bindStyle(jointsLinksFolder, 'linkColor', {
        label: 'Link Color',
        view: 'color'
    });
    bindStyle(jointsLinksFolder, 'randomJointColor', {
        label: 'Random Joint Color'
    });
    bindStyle(jointsLinksFolder, 'randomLinkColor', {
        label: 'Random Link Color'
    });
    bindStyle(jointsLinksFolder, 'jointRadius', {
        min: 0.01,
        max: 0.5,
        label: 'Joint Radius'
    });
    bindStyle(jointsLinksFolder, 'jointHeight', {
        min: 0.01,
        max: 0.5,
        label: 'Joint Height'
    });
    bindStyle(jointsLinksFolder, 'linkRadius', {
        min: 0.01,
        max: 0.2,
        label: 'Link Radius'
    });
    bindStyle(jointsLinksFolder, 'syncUp', {
        label: 'Sync Up'
    });
    const helpersFolder = $272bbf19d32de2d1$var$styleFolder.addFolder({
        title: 'Helpers'
    });
    const axisFolder = helpersFolder.addFolder({
        title: 'Axis'
    });
    bindStyle(axisFolder, 'showAxisHelper', {
        label: 'Axis Helper'
    });
    bindStyle(axisFolder, 'axisHelperSize', {
        min: 0.01,
        max: 2,
        label: 'Axis Size'
    });
    const dofFolder = helpersFolder.addFolder({
        title: 'DOF'
    });
    bindStyle(dofFolder, 'showDOFHelper', {
        label: 'DOF Helper'
    });
    bindStyle(dofFolder, 'dofColor', {
        label: 'DOF Color',
        view: 'color'
    });
    bindStyle(dofFolder, 'dofOpacity', {
        min: 0,
        max: 1,
        label: 'DOF Opacity'
    });
    bindStyle(dofFolder, 'dofUseJointColor', {
        label: 'Use Random Color'
    });
    bindStyle(dofFolder, 'dofUseAutoRadius', {
        label: 'DOF Auto Radius'
    });
    bindStyle(dofFolder, 'dofRadius', {
        min: 0.001,
        max: 2,
        label: 'DOF Radius'
    });
    bindStyle(dofFolder, 'dofRadiusScale', {
        min: 0.01,
        max: 1,
        label: 'DOF Radius Scale'
    });
    bindStyle(dofFolder, 'dofThicknessRatio', {
        min: 0.01,
        max: 1,
        label: 'DOF Thickness'
    });
    bindStyle(dofFolder, 'dofSegments', {
        min: 3,
        max: 128,
        step: 1,
        label: 'DOF Segments'
    });
    bindStyle(dofFolder, 'dofOffsetZ', {
        min: 0,
        max: 0.01,
        label: 'DOF Offset Z'
    });
    $272bbf19d32de2d1$var$styleFolder.addButton({
        title: 'Reset Styles'
    }).on('click', ()=>{
        $272bbf19d32de2d1$var$resetStyles();
    });
    $272bbf19d32de2d1$var$styleFolder.expanded = true;
    $272bbf19d32de2d1$var$armsFolder = $272bbf19d32de2d1$var$pane.addFolder({
        title: 'Link'
    });
    $272bbf19d32de2d1$var$armsFolder.expanded = true;
    window.addEventListener('resize', ()=>{
        const windwoWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        $272bbf19d32de2d1$var$renderer.setSize(windwoWidth, windowHeight);
        $272bbf19d32de2d1$var$camera.aspect = windwoWidth / windowHeight;
        $272bbf19d32de2d1$var$camera.updateProjectionMatrix();
        if ($272bbf19d32de2d1$var$chain.roboticArm) {
            const target = $272bbf19d32de2d1$var$chain.roboticArm.children.find((child)=>child.material && child.material.resolution);
            if (target) target.material.resolution.set(windwoWidth, windowHeight);
        }
        $272bbf19d32de2d1$var$renderLoop.requestRender();
    });
    $272bbf19d32de2d1$var$renderLoop.requestRender();
}
function $272bbf19d32de2d1$var$addEnvironment() {
    const floor = new (0, $jw0R5.Mesh)(new (0, $jw0R5.PlaneGeometry)(20, 20), new (0, $jw0R5.MeshStandardMaterial)({
        color: 0x596064,
        roughness: 0.82,
        metalness: 0.05
    }));
    floor.rotation.x = -Math.PI / 2;
    floor.position.y = -0.012;
    floor.receiveShadow = true;
    $272bbf19d32de2d1$var$scene.add(floor);
    const grid = new (0, $jw0R5.GridHelper)(20, 20, 0x7b8589, 0x687175);
    grid.position.y = -0.005;
    grid.material.transparent = true;
    grid.material.opacity = 0.24;
    $272bbf19d32de2d1$var$scene.add(grid);
    $272bbf19d32de2d1$var$scene.add(new (0, $jw0R5.AmbientLight)(0xffffff, 0.58));
    const hemisphere = new (0, $jw0R5.HemisphereLight)(0xf5fbff, 0x32383b, 1.45);
    hemisphere.position.set(0, 8, 0);
    $272bbf19d32de2d1$var$scene.add(hemisphere);
    const key = new (0, $jw0R5.DirectionalLight)(0xffffff, 4.2);
    key.position.set(5, 8, 6);
    key.castShadow = true;
    key.shadow.mapSize.set(2048, 2048);
    key.shadow.camera.left = -3;
    key.shadow.camera.right = 3;
    key.shadow.camera.top = 4;
    key.shadow.camera.bottom = -2;
    key.shadow.camera.near = 0.5;
    key.shadow.camera.far = 24;
    $272bbf19d32de2d1$var$scene.add(key);
    const fill = new (0, $jw0R5.DirectionalLight)(0xb9dcff, 1.3);
    fill.position.set(-5, 4, 4);
    $272bbf19d32de2d1$var$scene.add(fill);
    const rim = new (0, $jw0R5.DirectionalLight)(0xc0ecff, 1.45);
    rim.position.set(-3, 5, -6);
    $272bbf19d32de2d1$var$scene.add(rim);
}
function $272bbf19d32de2d1$var$updateArm() {
    if ($272bbf19d32de2d1$var$suppressUpdate) return;
    const dhParameters = $272bbf19d32de2d1$var$createDhParametersFromSegments($272bbf19d32de2d1$var$createParams.armSegments);
    $272bbf19d32de2d1$var$chain.update(dhParameters, $272bbf19d32de2d1$var$styleParams, $272bbf19d32de2d1$var$baseParams);
    $272bbf19d32de2d1$var$renderLoop.requestRender();
}
function $272bbf19d32de2d1$var$renderFrame() {
    $272bbf19d32de2d1$var$renderer.render($272bbf19d32de2d1$var$scene, $272bbf19d32de2d1$var$camera);
}


//# sourceMappingURL=dhLinks.853d9ce0.js.map
